import styled from 'styled-components'
import theme, { media } from 'theme'

const StyledHeader = styled.header<React.ComponentPropsWithoutRef<'header'>>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 8rem;
  padding: 0 3.2rem;
  z-index: 200;

  display: grid;
  grid-auto-flow: column;
  /* Left (title) yields first — it can shrink to nothing and its content clips —
     while center (stepper) and right (controls) keep their content size, so the
     controls are never squeezed/overlapped by a long title. */
  grid-template-columns: minmax(0, max-content) auto auto;
  align-items: center;

  background: ${theme.colors.white};
  box-shadow: inset 0 -0.1rem 0 ${theme.colors.grey[400]};

  ${media.belowLg} {
    /* Reserve room on the left for the layout's off-canvas menu button so it
       never overlaps the logo on tablet/phone. */
    padding-left: 8rem;

    /* Move the center content (the step rail) onto its own full-width second
       row so it stays visible without competing with the title/controls for
       horizontal space. Row 1 keeps the fixed 8rem height (title + controls);
       the rail row sits within the content area's top padding, so it never
       overlaps the page content. Pages with no center content (most of them)
       have an empty center cell, so the second row collapses to zero height and
       their header is unchanged. */
    height: auto;
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-rows: 8rem auto;
    grid-template-areas:
      'left right'
      'center center';
  }
`

const StyledHeaderLeftContentContainer = styled.div<
  React.ComponentPropsWithoutRef<'div'>
>`
  display: flex;
  justify-content: flex-start;
  /* Allow the left content (e.g. a long title) to shrink and clip instead of
     pushing into the controls. */
  min-width: 0;
  overflow: hidden;

  ${media.belowLg} {
    grid-area: left;
  }
`
const StyledHeaderCenterContentContainer = styled.div<
  React.ComponentPropsWithoutRef<'div'>
>`
  display: flex;
  justify-content: center;

  /* On tablet/phone the center sits on its own full-width row (see StyledHeader).
     Align it to the start and let it scroll sideways if the rail is wider than
     the viewport, instead of overflowing the header. */
  ${media.belowLg} {
    grid-area: center;
    justify-content: flex-start;
    min-width: 0;
    overflow-x: auto;
  }
`
const StyledHeaderRightContentContainer = styled.div<
  React.ComponentPropsWithoutRef<'div'>
>`
  display: flex;
  justify-content: flex-end;

  ${media.belowLg} {
    grid-area: right;
  }
`

export {
  StyledHeader,
  StyledHeaderLeftContentContainer,
  StyledHeaderCenterContentContainer,
  StyledHeaderRightContentContainer
}
